import {requestGet, requestPost} from '@/utils/request';

const api = {
    LIST: '/content/accost_tpl_list',
    ADD: '/content/accost_tpl_add',
    UPDATE: '/content/accost_tpl_update',
	DEL: '/content/accost_tpl_del',
	SET_ENABLE: '/content/accost_tpl_set_enable',
    IS_EXIST_TAG_NAME: '/content/accost_tpl_is_exist_tag_name',
    SCENE_TAG_SUGGEST: '/content/accost_scene_tag_suggest',
}

export async function accostList(queryParams) {
    return requestGet(api.LIST, queryParams);
}

export async function accostAdd(form) {
    return requestPost(api.ADD, form);
}

export async function accostUpdate(form) {
    return requestPost(api.UPDATE, form);
}

export async function accostDel(id) {
	let params = {id: id};
    return requestPost(api.DEL, params);
}

export async function accostSetEnable(id, enable) {
	let params = { id, enable};
    return requestPost(api.SET_ENABLE, params);
}

export async function accostTagNameIsExist(tagName) {
    let params = {val: tagName};
    return requestGet(api.IS_EXIST_TAG_NAME, params);
}

export async function accostSceneTagSuggest(keyword) {
    const kw = keyword != null ? String(keyword).trim() : '';
    const params = kw === '' ? {} : { keyword: kw };
    return requestGet(api.SCENE_TAG_SUGGEST, params);
}

